import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addLeadingZeros'
})
export class AddLeadingZerosPipe implements PipeTransform {

  transform(value: any, numberOfDigits: number): any {

    let trimedNumber: string = value.toString().trim();
    let currentNumberOfDigits: number = trimedNumber.length;

    for(let i = currentNumberOfDigits; i < numberOfDigits; i++) {
      trimedNumber = "0" + trimedNumber;
    }
    return trimedNumber;
  }
}
